<template>
    <v-btn tile :small="small" :color="color" @click="doHandlerClick()" :disabled="disabled">
      <v-icon left>{{iconCls}}</v-icon>{{label}}
    </v-btn>
</template>



<script>
export default {
  name: "RyouBlackBtn",
  props: {
    label: {
      type: String,
      required: false,
      default: ""
    },
    color: {
      type: String,
      required: false,
      default: "secondary"
    },
    iconCls: {
      type: String,
      required: false,
      default: "mdi-pencil"
    },
    handlerClick: {
      type: Function,
      required: false,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    small: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
    };
  },
  methods: {
    doHandlerClick() {
      this.handlerClick();
    }
  },
    computed: {
    }
};
</script>

<style scoped>
</style>
